import { SdgAlignmentLevel, SdgAlignmentStrength, SdgId } from '../../output/scores/sdg-alignment/types';
import { ByLanguage } from '../types';

export function friendlySdgAlignmentLevel(alignmentLevel: SdgAlignmentLevel) {
  switch (alignmentLevel) {
    case SdgAlignmentLevel.STRONGLY_ALIGNED:
      return 'Strongly aligned';
    case SdgAlignmentLevel.STRONGLY_MISALIGNED:
      return 'Strongly misaligned';
    case SdgAlignmentLevel.ALIGNED:
      return 'Moderately aligned';
    case SdgAlignmentLevel.MISALIGNED:
      return 'Moderately misaligned';
    case SdgAlignmentLevel.WEAKLY_ALIGNED:
      return 'Weakly aligned';
    case SdgAlignmentLevel.WEAKLY_MISALIGNED:
      return 'Weakly misaligned';
  }
}

export function friendlyAlignmentStrength(strength: SdgAlignmentStrength) {
  switch (strength) {
    case SdgAlignmentStrength.STRONG:
      return 'Strong';
    case SdgAlignmentStrength.NORMAL:
      return 'Moderate';
    case SdgAlignmentStrength.WEAK:
      return 'Weak';
  }
}

export function friendlySdgName(sdgId: SdgId, noNumber?: boolean) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const sdgName = sdgNamesByLanguage.en![sdgId];
  if (noNumber) {
    return sdgName;
  }
  return `${sdgId} - ${sdgName}`;
}

export const sdgNamesByLanguage: Partial<ByLanguage<Record<SdgId, string>>> = {
  en: {
    [SdgId._1_No_Poverty]: 'No Poverty',
    [SdgId._2_Zero_Hunger]: 'Zero Hunger',
    [SdgId._3_Good_Health_and_Wellbeing]: 'Good Health and Wellbeing',
    [SdgId._4_Quality_Education]: 'Quality Education',
    [SdgId._5_Gender_Equality]: 'Gender Equality',
    [SdgId._6_Clean_Water_and_Sanitation]: 'Clean Water and Sanitation',
    [SdgId._7_Affordable_and_Clean_Energy]: 'Affordable and Clean Energy',
    [SdgId._8_Decent_Work_and_Economic_Growth]: 'Decent Work and Economic Growth',
    [SdgId._9_Industry_Innovation_and_Infrastructure]: 'Industry, Innovation and Infrastructure',
    [SdgId._10_Reduced_Inequality]: 'Reduced Inequality',
    [SdgId._11_Sustainable_Cities_and_Communities]: 'Sustainable Cities and Communities',
    [SdgId._12_Responsible_Consumption_and_Production]: 'Responsible Consumption and Production',
    [SdgId._13_Climate_Action]: 'Climate Action',
    [SdgId._14_Life_Below_Water]: 'Life Below Water',
    [SdgId._15_Life_on_Land]: 'Life on Land',
    [SdgId._16_Peace_Justice_and_Strong_Institutions]: 'Peace, Justice and Strong Institutions',
    [SdgId._17_Partnerships_for_the_Goals]: 'Partnerships for the Goals',
  },
  // TODO translate and use in api/metrics/legend
  // fi: {},
  // sv: {},
};
